import {getStore} from "@/utils/store";

const state = {
    // 专业树结构列表
    majorTreeList: getStore({ name: 'majorTreeList' }) || null,
}

export default state
